var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 21,
    viewBox: "0 0 14 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 0.65625H3.25001C2.52066 0.65625 1.82119 0.982198 1.30546 1.56239C0.789736 2.14258 0.500005 2.92949 0.500005 3.75V19.5C0.498991 19.6549 0.535882 19.807 0.606636 19.9399C0.677391 20.0727 0.779278 20.1811 0.901139 20.2531C1.023 20.3252 1.16013 20.3581 1.29751 20.3483C1.43489 20.3385 1.56722 20.2863 1.68001 20.1975L7.00001 16.0238L12.32 20.1975C12.4467 20.2945 12.5968 20.3456 12.75 20.3438C12.871 20.3421 12.9904 20.3114 13.1 20.2537C13.2203 20.1796 13.3208 20.0706 13.3912 19.9381C13.4615 19.8056 13.4991 19.6543 13.5 19.5V3.75C13.5 2.92949 13.2103 2.14258 12.6946 1.56239C12.1788 0.982198 11.4794 0.65625 10.75 0.65625Z",
    fill: "#8E44AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmark);
export default __webpack_public_path__ + "static/media/bookmark.9c16d761108b1ca71156d88ae7db5988.svg";
export { ForwardRef as ReactComponent };